export const de = {
  metadata: {
    home: {
      title: 'Rabatte für Alltagshelden',
      description:
        'Entdecke die besten Rabatte, exklusiven Angebote und Gutscheine nur für verifizierte Benutzer. Spare mehr bei Deinen Lieblingsmarken und -geschäften mit unseren handverlesenen Deals. Fang noch heute an, schlauer einzukaufen!'
    },
    about: {
      title: 'Über uns',
      description:
        'Entdecke die Geschichte hinter unserer Gutschein-Website! Wir widmen uns der Aufgabe, Dir mit den neuesten Angeboten, Rabatten und exklusiven Deals Geld zu sparen. Unsere Mission ist es, das Einkaufen intelligenter und erschwinglicher zu machen, indem wir Dich mit vertrauenswürdigen Einzelhändlern und den besten Schnäppchen verbinden. Erfahre mehr darüber, wie wir das Sparen für Dich einfach und nahtlos gestalten!'
    },
    imprint: {
      title: 'Impressum',
      description:
        'Finde wichtige Unternehmensinformationen, einschließlich rechtlicher Details und Kontaktdaten, auf unserer Impressum-Seite. Wir gewährleisten Transparenz, indem wir alle erforderlichen Angaben gemäß geltender Vorschriften bereitstellen. Erfahre mehr über unsere Unternehmensidentität und wie Du uns erreichen kannst.'
    },
    termsAndConditions: {
      title: 'Allgemeine Geschäftsbedingungen',
      description:
        'Lies unsere Allgemeinen Geschäftsbedingungen, um die Regeln und Richtlinien für die Nutzung unserer Website und Dienstleistungen zu verstehen. Diese Seite enthält Deine Rechte, Pflichten und wichtige rechtliche Informationen, um ein transparentes und vertrauenswürdiges Erlebnis zu gewährleisten.'
    },
    dataProtection: {
      title: 'Datenschutz',
      description:
        'Erfahre, wie wir Deine Privatsphäre priorisieren und Deine persönlichen Daten schützen. Auf unserer Datenschutzseite erfährst Du, welche Maßnahmen wir ergreifen, um die Einhaltung der Datenschutzgesetze zu gewährleisten, Transparenz zu schaffen und Deine Informationen zu sichern. Entdecke Deine Rechte und wie wir mit Deinen Daten verantwortungsvoll umgehen.'
    },
    contact: {
      title: 'Du hast Fragen?',
      description:
        'Kontaktiere uns! Hast Du Fragen, Feedback oder benötigst Du Hilfe? Unser Team ist hier, um Dir zu helfen. Besuche unsere Kontaktseite, um schnelle und einfache Möglichkeiten zu finden, uns zu erreichen, einschließlich E-Mail, Telefon oder Live-Chat. Wir schätzen Dein Feedback und sind bestrebt, hervorragenden Support zu bieten!'
    },
    whatIsIhrhelden: {
      title: 'Was ist ihrHelden?',
      description:
        'Auf unserer “Was ist ihrHelden?”-Seite erfährst Du, welche Berufsgruppen sich anmelden können, welche exklusiven Angebote wir bereithalten und wie Du Dich verifizieren kannst, um Zugang zu erhalten.'
    },
    category: {
      title: 'Rabatte für Dich'
    },
    subCategory: {
      title: 'Rabatte & Angebote',
      description1: 'Entdecke die besten Rabatte und Angebote in',
      description2: 'Entdecke Top-Einzelhändler, exklusive Angebote und mehr!'
    },
    retailer: {
      title: 'Angebote & Rabatte',
      description: 'bietet tolle Angebote und exklusive Rabatte.'
    },
    highlights: {
      title: 'Highlights',
      description:
        'Aktuelle Kampagnen, saisonale Aktionen und handverlesene Angebote unserer Partner — auf einen Blick bei ihrHelden.'
    },
    retailersAZ: {
      title: 'Alle Händler A–Z',
      description:
        'Alle Händler mit aktuellen Angeboten alphabetisch sortiert von A bis Z. Finde Deine Lieblingsmarke schnell und entdecke exklusive Rabatte auf ihrHelden.'
    },
    deal: {
      title: 'Exklusives Angebot',
      description: 'Entdecke tolle Rabatte und Angebote!',
      unknownRetailer: 'Unbekannter Einzelhändler',
      deals: 'Angebote',
      description1: 'Finde die besten Angebote für',
      at: 'bei',
      saveNow: 'Jetzt sparen!',
      openGraphDescription: 'Entdecke Rabatte und Angebote für'
    },
    savedDeals: {
      title: 'Meine Deals',
      description:
        'Alle Deine gespeicherten Deals auf einen Blick. Verpasse keine exklusiven Angebote und Rabatte, die Du Dir gemerkt hast.'
    },
    search: {
      title: 'Suchergebnisse',
      description:
        'Durchsuche exklusive Rabatte und Angebote unserer Partner-Shops für Alltagshelden.'
    },
    profile: {
      title: 'Mein Profil'
    },
    referral: {
      title: 'Freunde einladen'
    }
  },
  maintenance: {
    title: 'Kurze Wartungspause',
    description:
      'Wir arbeiten gerade an unseren Systemen. In wenigen Minuten sind wir wieder für Dich da.',
    retryIn: 'Nächster automatischer Versuch in {seconds} s',
    retryNow: 'Jetzt erneut versuchen'
  },
  error: {
    somethingWentWrong: 'Upps, da ist etwas falsch gelaufen.',
    unableToFetchData:
      'Daten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.',
    noDeals: 'Keine Angebote gefunden',
    reload: 'Neu laden',
    error: 'Fehler'
  },
  formSchema: {
    emailRequired: 'E-Mail kann nicht leer bleiben',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    passwordRequired: 'Passwort kann nicht leer bleiben',
    passwordMin: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    passwordMatch:
      'Das Passwort muss mindestens 1 Zahl und 1 Buchstaben enthalten',
    confirmPasswordRequired: 'Bitte geben Sie Ihr Passwort erneut ein',
    confirmPasswordMatch: 'Die Passwörter stimmen nicht überein',
    currentPasswordRequired: 'Bitte geben Sie Ihr altes Passwort ein',
    newPasswordRequired: 'Bitte geben Sie Ihr neues Passwort ein',
    firstNameRequired: 'Vorname kann nicht leer bleiben',
    firstNameMin: 'Vorname kann nicht kürzer sein als 2 Zeichen!',
    firstNameMax: 'Vorname kann nicht länger sein als 40 Zeichen!',
    lastNameRequired: 'Nachname kann nicht leer bleiben',
    lastNameMin: 'Nachname kann nicht kürzer sein als 2 Zeichen!',
    lastNameMax: 'Nachname kann nicht länger sein als 40 Zeichen!',
    isAgreedToTermsAndConditions: 'Das Feld muss angekreuzt werden',
    industryTypeIdRequired: 'Bitte wähle Deine Branche aus',
    industryIdRequired: 'Arbeitsplatz kann nicht leer bleiben',
    designationIdRequired: 'Berufsbezeichnung kann nicht leer bleiben',
    workEmailRequired: 'Arbeits-E-Mail kann nicht leer bleiben',
    workEmailInvalid: 'Bitte geben Sie Ihre Arbeits-E-Mail ein',
    workDocumentRequired: 'Arbeitsdokument kann nicht leer bleiben',
    fileTypeInvalid:
      'Ungültiges Dateiformat. Nur .png, .jpg, .jpeg, .pdf sind erlaubt.',
    nameRequired: 'Name kann nicht leer bleiben',
    nameMin: 'Der Name muss mindestens 2 Zeichen enthalten',
    nameMax: 'Der Name darf nicht mehr als 40 Zeichen enthalten',
    messageRequired: 'Beschreibung kann nicht leer bleiben',
    messageMin: 'Die Beschreibung muss mindestens 10 Zeichen enthalten',
    messageMax: 'Die Beschreibung darf nicht mehr als 300 Zeichen enthalten'
  },
  constant: {
    authStatus: {
      email: {
        title: 'Bitte schau in Deinem E-Mail Postfach nach.',
        description: 'Wir haben Dir eine E-Mail an',
        additionalDescription: 'geschickt',
        additionalInfo: ''
      },
      docUpload: {
        title: 'Super! Dein Dokument wurde erfolgreich hochgeladen.',
        description:
          'Wir werden schnellstmöglich Dein Dokument prüfen. Nach Abschluss löschen wir die Daten wieder.',
        additionalInfo:
          'Wir melden uns schnellstmöglich per E-Mail bei Dir. Schreib uns einfach in der Zwischenzeit an kontakt@ihrhelden.de, falls Du Fragen hast.'
      }
    },
    verificationMessages: {
      empty: {
        title: 'Bitte überprüfe Deine E-Mails',
        description:
          'Eine E-Mail wurde gesendet. Bitte überprüfen Sie Deinen Posteingang und folge den Anweisungen.',
        additionalInfo: 'schaue bitte auch im Spam-Ordner'
      },
      expired: {
        title: 'Link abgelaufen!',
        description: 'Upps, der Link wurde schon benutzt.',
        actionButton: 'Erneut versuchen'
      },
      invalid: {
        title: 'Link ungültig!',
        description: 'Der Link ist nicht gültig.',
        actionButton: 'Erneut versuchen'
      },
      default: {
        title:
          'Bitte warte noch einen Moment. Unser System prüft Deine Angaben.',
        description: 'Wir prüfen Deine Angaben',
        additionalInfo:
          'Wusstest Du schon, wir haben regelmäßig neue Aktionen bei denen Du sparen kannst. schau regelmäßig vorbei!',
        rightSideInfo:
          'Registriere Dich und werde Mitglied bei Deutschlands erster Shopping-Community nur für Alltagshelden!'
      }
    },
    verificationStatus: {
      pending: {
        title: 'Verifizierung läuft!',
        description:
          'Bitte bestätige Deine Arbeits-Email Adresse. Wenn dies nicht klappt, kannst Du es mit einer anderen Email Adresse oder am Besten mit einem Arbeitsdokument versuchen.',
        additionalInfo: 'Nach der Verifizierung können Sie die Rabatte nutzen.',
        actionButton: 'Code eingeben'
      },
      verified: {
        title: 'Super! Diese Email gehört einem Alltagsheld. ',
        description: 'Du kannst Dich jetzt einloggen und sofort losshoppen',
        additionalInfo: ''
      },
      rejected: {
        title: 'Upps, wir konnten Dich leider nicht verifizieren. 😥',
        description:
          'Private E-Mail-Adressen funktionieren nicht!\n❌ Funktioniert nicht: @gmail.com, @gmx.de, @web.de usw.\n🟢 Funktioniert: @dein-arbeitgeber.de (Arbeits-E-Mail)\n\nDu hast keine Arbeits-E-Mail? Dann lade einfach ein Nachweisdokument (z.B. Dienstausweis oder Namensschild) hoch.',
        additionalInfo:
          'Auch wir machen Fehler, daher kannst Du auch gerne Kontakt zu uns unter kontakt@ihrhelden.de aufnehmen.',
        actionButton: 'Erneut versuchen'
      },
      manual: {
        title: 'Deine E-Mail-Adresse wird von uns manuell überprüft.',
        description:
          'Bitte hab ein wenig Geduld. Wir melden uns schnellstmöglich.',
        additionalInfo:
          'Wenn Du nicht so lange warten willst, kannst Du uns ein Arbeitsdokument hochladen',
        actionButton: 'Arbeitsdokument hochladen'
      }
    },
    dynamicButtons: {
      becomeMember: 'Anmelden',
      becomeMemberLong: 'Anmelden und beim Shoppen sparen',
      verifyAccount: 'Account verifizieren',
      verifyAccountLong:
        'Bestätige Deinen Alltagshelden Status und spare mit unseren exklusiven Rabatten',
      completeProfile: 'Profil vervollständigen',
      completeProfileLong:
        'Vervollständige Dein Profil und spare mit unseren exklusiven Rabatten',
      verifyWorkEmail: 'Verifizierung läuft...',
      verifyWorkEmailLong: 'Deine Held:innen-Verifizierung läuft',
      rejectedIdentity: 'Erneut versuchen',
      rejectedIdentityLong: 'Erneut versuchen und sparen',
      referAFriend: 'Helden werben Helden',
      inviteMoreHeroes: 'Weitere Helden einladen',
      referAFriendLong: 'Weitere Helden einladen'
    },
    footers: {
      title: 'ihrHelden',
      about: 'Über uns',
      whatIsIhrhelden: 'Was ist ihrhelden.de',
      retailersAZ: 'Alle Händler A–Z',
      imprint: 'Impressum',
      contact: 'Kontakt',
      partner: 'Unsere Partner',
      termsAndConditions: 'Nutzungsbedingungen',
      dataProtection: 'Datenschutz',
      cookiePreference: 'Cookie Einstellungen'
    }
  },
  highlights: {
    retailersTitle: 'Unsere Partner',
    dealsTitle: 'Aktuelle Angebote',
    empty: 'Zurzeit sind hier keine Inhalte verfügbar.'
  },

  home: {
    getTheDeal: 'Code anzeigen',
    topRetailerTitle: 'Unsere besten Partner',
    topRetailerSeeAll: 'Alle ansehen',
    offer: 'Angebot',
    offers: 'Angebote',
    userHasRedeemed: 'Alltagsheld:innen haben',
    codes: 'Rabatte genutzt',
    learnMore: 'Mehr erfahren',
    categorySushiBar: {
      title: 'Entdecke weitere Kategorien'
    }
  },
  marketingBanner: {
    // Zugänglicher Name, wenn ein Banner weder Überschrift noch CTA-Text hat.
    defaultLabel: 'Aktion'
  },
  referral: {
    title:
      'Du kennst noch andere Held:innen die auch sparen können?\nSuper, dann lad’ sie ein und belohne Dich selbst!',
    description:
      'Für je 2 erfolgreiche Empfehlungen bekommst Du von uns einen 5€ Amazon Gutschein – ganz einfach per E-Mail.',
    getLinkButton: 'Deinen Einladungs-Link kopieren',
    steps: {
      howItWorks: 'So einfach funktioniert’s:',
      title: 'Hilf anderen Held:innen in 3 Schritten zu sparen.',
      step1: {
        title: '🔗 Teile Deinen Link',
        description:
          'Kopiere Deinen persönlichen Empfehlungs-Link und schick ihn an Freund:innen und Kolleg:innen - wie Du möchtest, per Whatsapp, email, etc.'
      },
      step2: {
        title: '📩 Neue Alltagsheld:innen registrieren sich',
        description:
          'Sobald sich jemand über Deinen Link “vollständig registriert” und verifiziert, zählt das als erfolgreiche Empfehlung.'
      },
      step3: {
        title: '🎁 Erhalte Deinen Gutschein für Deinen Einsatz',
        description:
          'Für je 2 vollständig registrierte Alltagsheld:innen schicken wir Dir einen 5 € Amazon Gutschein per E-Mail zu.'
      }
    },
    faq: {
      title: 'FAQ-Bereich',
      questions: [
        {
          id: 1,
          question: 'Was heißt „vollständig registriert“?',
          answer:
            'Neue Nutzer:innen müssen ihre private E-Mail-Adresse bestätigen und sich entweder per Arbeits-E-Mail oder mit einem Arbeitsnachweis als Alltagsheld:in verifizieren. Erst wenn die Anmeldung vollständig abgeschlossen ist, zählt der neue Nutzer als “vollständig registriert”'
        },
        {
          id: 2,
          question: 'Was passiert, wenn jemand die Registrierung unterbricht?',
          answer:
            'Wenn die Seite geschlossen wird, können wir die Empfehlung leider nicht mehr korrekt zuordnen. Bitte informiere Deine Freund:innen und Kolleg:innen, dass sie den Prozess am Stück abschließen sollen. Es ist besonders wichtig, dass die neuen Alltagsheld:innen den Prozess über Deinen persönlichen Einladungs-Link starten.'
        },
        {
          id: 3,
          question: 'Wann erhalte ich meinen Gutschein?',
          answer:
            'Sobald 2 Personen über Deinen Link registriert und vollständig verifiziert wurden, schicken wir Dir den Gutschein per E-Mail.'
        },
        {
          id: 4,
          question: 'Gibt es ein Limit für Empfehlungen?',
          answer:
            'Nein! Je mehr Alltagsheld:innen Du einlädst, desto mehr Gutscheine kannst Du sammeln (Um Missbrauch zu vermeiden und fair zu bleiben, prüfen wir verdächtige Anmeldungen bei Bedarf. In solchen Fällen behalten wir uns vor, die Gutscheinvergabe auszusetzen.)'
        }
      ]
    }
  },
  auth: {
    notFound: {
      description: 'Etwas fehlt',
      message:
        'Entschuldigung, die Seite, die Sie suchen, existiert nicht oder wurde verschoben.',
      goBack: 'Zurück',
      backToHome: 'Zur Startseite'
    },
    error: {
      title: 'Huch!',
      description: 'Ups... es liegt nicht an dir, sondern an uns.',
      message: 'Fehlermeldung',
      button: 'Versuchen Sie es erneut'
    },
    responseModal: {
      success: 'Super!',
      somethingWentWrong: 'Etwas ist schief gelaufen!',
      resetPasswordError: 'Fehler beim Zurücksetzen des Passworts!',
      forgotPasswordError: 'Fehler beim Zurücksetzen des Passworts!',
      forgotPasswordSuccess: 'Passwort erfolgreich zurückgesetzt!',
      changePasswordError: 'Fehler beim Ändern des Passworts!',
      changePasswordSuccess: 'Passwort erfolgreich geändert!',
      loginError: 'Fehler beim Login!',
      registerError: 'Fehler bei der Registrierung!',
      otpVerifyError: 'Eingabe falsch',
      otpResendError: 'Fehler beim erneuten Senden des Codes!',
      otpResendSuccess: 'Wir haben Dir einen neuen Code geschickt.'
    },
    icons: {
      exclusive: 'Exklusiv',
      hot: 'Hot',
      sale: 'Sale',
      sustainable: 'Nachhaltig',
      other: 'Andere'
    },
    resetPassword: {
      title: 'Passwort zurücksetzen',
      email: 'Persönliche E-Mail',
      emailDescription:
        'Bitte gib Deine E-Mail-Adresse ein, mit der Du das Konto erstellt hast!',
      buttonText: 'Weiter'
    },
    forgotPassword: {
      title: 'Neues Passwort erstellen',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      buttonText: 'Passwort festlegen'
    },
    changePassword: {
      title: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Neues Passwort bestätigen',
      buttonText: 'Passwort festlegen'
    },
    identityVerify: {
      buttonText: 'Jetzt entdecken',
      rightSideInfoVerified: 'Willkommen bei ihrHelden'
    },
    login: {
      title: 'Anmelden',
      subTitle: 'Einloggen oder',
      registerLinkText: 'hier neuen Account erstellen',
      email: 'Deine E-Mail Adresse',
      password: 'Passwort',
      forgotPasswordLinkText: 'Passwort vergessen?',
      buttonText: 'Login'
    },
    register: {
      title: 'Registriere Dich bei ihrHelden',
      subTitle: 'Erstelle Deinen kostenlosen Account oder',
      loginLinkText: 'Anmelden',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'Email',
      emailInfo: 'Wie können wir Dich erreichen?',
      password: 'Passwort wählen',
      confirmPassword: 'Passwort wiederholen',
      industryType: 'In welcher Branche arbeitest Du?',
      isAllowNewsLetter: `Ja, ich möchte gerne über personalisierte E-Mails von der Helden GmbH über tolle Sparmöglichkeiten, Rabatte und Aktionen informiert werden. Natürlich kann ich diese Einwilligungen jederzeit mit Wirkung für die Zukunft widerrufen – einfach über [Mein Profil] oder per E-Mail an <a href="mailto:datenschutz@ihrhelden.de" class="underline" target="_blank">datenschutz@ihrhelden.de</a>. Mehr Infos findest Du in unseren Datenschutzhinweisen.`,
      isAgreedToTermsAndConditions: `Ich stimme den <a href="/terms-and-conditions" class="underline" target="_blank">AGBs</a> zu. Deine Daten gehören Dir. Wir werden Deine Daten nur verwenden, um Dir die von Dir gewählten Produkte und Dienste anbieten zu können.`,
      buttonText: 'Weiter',
      step: 'Schritt',
      of: 'von',
      rightSideInfo:
        'Registriere Dich und werde Mitglied bei Deutschlands erster Shopping-Community nur für Alltagshelden!'
    },
    completeProfile: {
      title: 'Lass uns rausfinden, ob Du ein echter Alltagsheld bist',
      subTitle: '',
      industry: 'Ich arbeite bei/in',
      designation: 'als eine/einer',
      designationNote:
        'Falls Deine genaue Berufsbezeichnung nicht aufgeführt ist, wähle bitte die am besten passende aus.',
      verifyWorkTitle: 'Verifizere Deinen Arbeitsplatz',
      tab1: '(Arbeits-)E-Mailadresse',
      tab2: 'Arbeitsdokument',
      note: 'Du kannst Dich mit praktisch jedem Nachweis verifizieren, der zeigt, dass Du zu unseren Alltagshelden gehörst (z.B. Namensschild-Foto, Dienstausweis, Dienstplan, Urkunde, geschwärzte Gehaltsabrechnung, Bestätigung von Verein/Arbeitgeber oder Arbeitsvertrag)  und wir löschen das Dokument direkt nach der Prüfung.',
      buttonText: 'Mitglied werden',
      step: 'Schritt',
      of: 'von',
      uploadFailed:
        'Der Upload ist fehlgeschlagen. Bitte versuche es noch einmal.',
      rightSideInfo:
        'Bestätige Deine E-Mail-Addresse um keine Deals zu verpassen'
    },
    dragAndDrop: {
      text1:
        'Lade Dein Arbeitsdokument ganz einfach hoch – ziehe eine Datei (.pdf, .jpg, .jpeg, .png) hierher oder',
      text2: 'durchsuche',
      text3: 'Dein Gerät',
      fileTooLarge:
        'Die Datei ist zu groß. Bitte lade eine Datei unter 5 MB hoch.',
      tooManyFiles: 'Bitte wähle nur eine Datei aus.',
      takePhoto: 'Foto aufnehmen',
      photoPreviewAlt: 'Vorschau Deines Dokuments'
    },
    otpVerify: {
      title: 'Bestätige Deine E-Mail-Adresse',
      workEmailTitle: 'Bestätige Deine Arbeits-E-Mail Adresse',
      description:
        'Wir haben Dir einen Bestätigungscode an Deine E-Mail-Adresse gesendet.',
      didnTReceiveCode: 'Hast Du den Code nicht erhalten?',
      resendCode: 'Code erneut senden',
      resending: 'Code wird erneut gesendet...',
      verify: 'Code bestätigen',
      verifying: 'Überprüfen...',
      enterCode: 'Gib den Bestätigungscode ein',
      digitLabel: 'Ziffer {index} des Bestätigungscodes',
      wrongWorkEmail: 'Email Adresse nicht korrekt?',
      wrongWorkEmailLink: 'Hier anpassen',
      wrongPersonalEmail: 'Email Adresse nicht korrekt?',
      wrongPersonalEmailLink: 'Hier anpassen',
      changeEmailTitle: 'E-Mail-Adresse ändern',
      currentEmailLabel: 'Aktuelle E-Mail-Adresse',
      newEmailLabel: 'Neue E-Mail-Adresse',
      newEmailPlaceholder: 'name@beispiel.de',
      newEmailSend: 'Code senden',
      newEmailCancel: 'Abbrechen',
      newEmailSuccess:
        'Wir haben Dir einen neuen Bestätigungscode an Deine neue E-Mail-Adresse gesendet.'
    }
  },
  layout: {
    language: 'Deutsch',
    viewAllInCategory: 'Alle anzeigen',
    searchPlaceholder: 'Suchen...',
    searchButton: 'Suchen',
    clearSearch: 'Suche löschen',
    searchDropdown: {
      label: 'Suchvorschläge',
      close: 'Vorschläge schließen',
      featuredOffers: 'Empfohlene Angebote',
      featuredRetailers: 'Empfohlene Marken',
      resultOffers: 'Angebote',
      resultRetailers: 'Marken',
      viewAllRetailers: 'Alle Marken ansehen',
      loading: 'Vorschläge werden geladen',
      noResults: 'Nichts gefunden',
      error: 'Die Suche ist derzeit nicht verfügbar'
    },
    openMenu: 'Menü öffnen',
    blog: 'Blog',
    highlights: 'Highlights',
    profile: 'Mein Profil',
    savedDeals: 'Meine Deals',
    logout: 'Logout',
    breadcrumb: {
      home: 'Startseite',
      profile: 'Profil',
      contact: 'Kontakt',
      about: 'Über uns',
      imprint: 'Impressum',
      'terms-and-conditions': 'Bedingungen',
      'data-protection': 'Datenschutz',
      retailers: 'Händler',
      'saved-deals': 'Meine Deals'
    },
    socialBellMenu: {
      dealsFirst: 'Deals zuerst auf Social Media',
      toggleLabel: 'Social-Media-Menü'
    }
  },
  profile: {
    notAvailable: 'Nicht verfügbar',
    personalDetails: {
      title: 'Deine Informationen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      password: 'Passwort',
      passwordAction: 'Passwort ändern'
    },
    workplaceInformation: {
      title: 'Informationen über Deinen Arbeitsplatz',
      verifyDocument: {
        title: 'Bitte bestätige, dass Du ein Alltagsheld bist',
        description:
          'Bitte nutze hierzu Deine (Arbeits-)E-Mailadresse oder ein Arbeitsdokument',
        buttonText: 'Account verifizieren'
      },
      documentUploaded:
        'Vielen Dank für das Hochladen Ihrer Dokumente! Wir melden uns bei Ihnen über die von Ihnen angegebene E-Mail-Adresse.',
      profileFields: {
        industryType: 'Deine Industrie',
        industry: 'Dein Arbeitgeber',
        designation: 'Dein Job',
        workEmail: 'Deine (Arbeits-)E-Mailadresse'
      }
    },
    newsLetter: {
      title: 'Angebote und Benachrichtigungen',
      subTitle: 'Newsletter',
      subscribe: 'Abonnieren',
      unsubscribe: 'Abbestellen',
      description: 'Werde über Angebote benachrichtigt',
      toggleModal: {
        title: 'Angebote und Aktionen',
        description: 'Erlaube uns, Dir Angebote und Aktionen zu schicken',
        buttonText: 'Einstellungen speichern'
      },
      responseModal: {
        successSubscribe: 'Erfolgreich für den Newsletter angemeldet!',
        successUnsubscribe: 'Erfolgreich vom Newsletter abgemeldet!',
        errorSubscribe: 'Fehler beim Abonnieren des Newsletters!',
        errorUnsubscribe: 'Fehler beim Abmelden vom Newsletter!'
      }
    },
    referrals: {
      title: 'Empfiehl uns weiter -',
      description: 'damit auch andere Alltagshelden sparen'
    },
    pushNotifications: {
      title: 'Benachrichtigungen',
      description:
        'Erhalte sofort eine Benachrichtigung, sobald ein neuer Deal bei Deinen Lieblingsmarken erscheint oder ein gemerkter Deal wieder verfügbar ist.',
      enableButton: 'Jetzt Benachrichtigungen aktivieren',
      notNow: 'Vielleicht später',
      disableButton: 'Benachrichtigungen deaktivieren',
      unsupported: 'Dein Browser unterstützt keine Benachrichtigungen.',
      denied:
        'Die Benachrichtigungen sind blockiert. Bitte aktiviere diese in Deinen Browsereinstellungen.',
      iosHint:
        'Auf dem iPhone: Tippe auf Teilen → Zum Home-Screen, dann öffne die App und aktiviere Benachrichtigungen.',
      enabled: 'Benachrichtigungen aktiviert',
      disabled: 'Benachrichtigungen deaktiviert',
      enableSuccess: 'Benachrichtigungen aktiviert.',
      disableSuccess:
        'Wir haben die Benachrichtigungen pausiert. Besuche Deine Browsereinstellungen, um sie vollständig zu entfernen.',
      disableShowHow: 'So geht’s',
      genericError:
        'Wir konnten die Benachrichtigungen nicht aktualisieren. Bitte versuche es erneut.',
      serviceWorkerError:
        'Der Benachrichtigungs-Service-Worker konnte nicht registriert werden. Bitte lade die Seite neu und versuche es erneut.',
      pushServiceError:
        'Dein Browser konnte keine Verbindung zu seinem Push-Dienst herstellen. In Brave aktiviere bitte „Google-Dienste für Push-Nachrichten verwenden“ in den Datenschutzeinstellungen; prüfe sonst, ob ein VPN oder eine Firewall ihn blockiert.'
    },
    deleteAccount: {
      title: 'Konto löschen',
      description:
        'Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden.',
      currentPassword: 'Aktuelles Passwort',
      buttonText: 'Löschen',
      responseModal: {
        success: 'Konto erfolgreich gelöscht!',
        error: 'Konto konnte nicht gelöscht werden!'
      }
    },
    downloadData: 'Meine Daten herunterladen'
  },
  search: {
    searchResults: 'Suchergebnis für',
    noResults: 'Kein Suchergebnis für',
    recommendedRetailers: 'Unsere Empfehlung',
    noDeals: 'Keine Angebote für diese Suche gefunden'
  },
  retailersAZ: {
    title: 'Alle Händler A–Z',
    navAriaLabel: 'Händler nach Anfangsbuchstaben',
    noRetailers: 'Derzeit sind keine Händler verfügbar.',
    noRetailersForLetter: 'keine Händler'
  },
  category: {
    ourBest: 'Unsere besten',
    title: 'Angebote für Dich',
    top: 'Top',
    deals: 'Angebote',
    seeAll: 'Alle ansehen'
  },
  subCategory: {
    title: 'Die besten Angebote für'
  },
  deal: {
    dealOfTheDay: 'Angebot des Tages',
    countdownPrefix: 'Noch',
    countdownUnitSingular: 'Tag',
    countdownUnitPlural: 'Tage',
    brandLogoAlt: 'Logo',
    retailerInfo: 'Händler Informationen',
    noRetailerInfo: 'Keine Informationen zum Einzelhändler verfügbar',
    termsAndConditions: 'Nutzungsbedingungen',
    noTermsAndConditionsInfo: 'Keine Geschäftsbedingungen verfügbar',
    dealBy: 'Angebot von',
    viewAllDealsBy: 'Alle Angebote von',
    verifyAccount:
      'Ihre Arbeitsidentität ist noch nicht verifiziert. Bitte verifizieren Sie Ihre Arbeitsidentität, um den Code zu erhalten.',
    getTheCode: 'Jetzt sparen',
    note: {
      title: 'So funktioniert’s:',
      description: [
        'Klick auf "Zum Deal - Deinen Code anzeigen"',
        'Gutscheincode kopieren',
        'Rabatt direkt im Warenkorb einlösen ✅'
      ]
    },
    codeAlreadyUsed: 'Codes genutzt',
    copy: 'Kopieren',
    copied: 'Kopiert',
    copyFailed: 'Fehlgeschlagen',
    copyFailedManual:
      'Kopieren fehlgeschlagen – der Code ist markiert, kopiere ihn manuell.',
    codeLimitReached:
      'Du hast die maximale Anzahl an Codes für dieses Angebot erreicht. Das ist Dein zuletzt erhaltener Code.',
    codeOutOfStock:
      'Für dieses Angebot gibt es gerade keine neuen Codes. Das ist Dein zuletzt erhaltener Code.',
    continue: 'Zum Shop',
    continueTo: 'Weiter zu',
    redeemNow: 'Zum Deal - Deinen Code anzeigen',
    loading: 'Lade Angebote...',
    feedback: {
      question: 'Hat es geklappt?',
      thumbsUpLabel: 'Ja, hat geklappt',
      thumbsDownLabel: 'Nein, hat nicht geklappt',
      thankYou: 'Danke! Wir schauen uns Deine Meldung an.',
      noCode: 'Löse zuerst den Code ein, dann sag uns, wie es lief.',
      capReached:
        'Du hast bereits die maximale Anzahl an Codes für dieses Angebot gemeldet.',
      questionCodeless: 'War das Angebot gut?',
      thumbsUpLabelCodeless: 'Ja, gutes Angebot',
      thumbsDownLabelCodeless: 'Nein, kein gutes Angebot',
      notAccepted: 'Deine Bewertung konnte gerade nicht gezählt werden.',
      submitError:
        'Deine Bewertung konnte nicht gespeichert werden. Bitte versuche es erneut.',
      reasonDialog: {
        title: 'Was ist schiefgelaufen?',
        description:
          'Optional: Erzähl uns mehr, damit wir das Angebot prüfen können.',
        chipsLabel: 'Schnellauswahl',
        textareaLabel: 'Deine Rückmeldung (optional)',
        placeholder: 'Was ist passiert?',
        charactersUsed: 'Zeichen verwendet',
        send: 'Senden',
        skip: 'Überspringen',
        reasons: {
          codeDidntWork: 'Code hat nicht funktioniert',
          codeAlreadyUsed: 'Code bereits verwendet',
          offerExpired: 'Angebot abgelaufen',
          priceDifferent: 'Preis war anders',
          other: 'Sonstiges'
        }
      }
    },
    share: {
      button: 'Teilen',
      ariaLabel: 'Diesen Deal teilen',
      whatsapp: 'WhatsApp',
      copyLink: 'Link kopieren',
      copied: 'Kopiert',
      error: 'Teilen hat nicht geklappt. Bitte versuche es erneut.',
      // {retailer} and {value} come from the deal; the link is appended after it.
      messageTemplate:
        "Schau mal 👀 Bei {retailer} gibt's gerade {value} exklusiv für Alltagsheld:innen über ihrHelden:",
      // Used as {value} for percentage deals.
      percentValue: '{value} % Rabatt',
      // Used as {value} for flat deals; only an unknown type falls back to the deal title.
      flatValue: '{value} € Rabatt'
    }
  },
  availablePlans: {
    heading: 'Verfügbare Tarife',
    subheading: 'Alle Tarife inkl. exklusiver Vorteile für Alltagsheld:innen.',
    compareHint: 'Tarife vergleichen',
    selectPlan: 'Zum Tarif',
    viewDetails: 'Tarifdetails ansehen',
    instead: 'statt',
    perMonthFallback: '/ Monat',
    plansTab: 'Tarife',
    calculatorTab: 'Tarifrechner',
    calculatorLoading: 'Vergleich wird geladen…',
    widgetConsentMessage:
      'Der Tarifrechner unseres Partners wird erst nach deiner Einwilligung in den Cookie-Einstellungen geladen.',
    widgetConsentCta: 'Cookie-Einstellungen öffnen',
    lockedTitle: 'Für Alltagshelden: Tarife nach Anmeldung sichtbar',
    lockedMessage:
      'Melde dich an, um alle Tarife und exklusiven Held:innen-Vorteile zu sehen.',
    lockedCta: 'Anmelden',
    dummyBadge: 'Beliebt',
    dummyPlanS: 'Tarif S',
    dummyPlanM: 'Tarif M',
    dummyPlanL: 'Tarif L',
    dummyFeatureData: 'Inklusivvolumen',
    dummyFeatureNetwork: 'Schnelles Netz',
    dummyFeatureFlat: 'Allnet-Flat'
  },
  contact: {
    title: 'Du hast Fragen?',
    description:
      'Fülle einfach das Kontaktformular aus und wir werden Dir schnellstmöglich helfen.',
    name: 'Name',
    email: 'Email',
    message: 'Deine Nachricht',
    submit: 'Absenden',
    success: 'Nachricht erfolgreich gesendet!',
    error: 'Fehler beim Senden der Nachricht!',
    recaptchaError: 'reCAPTCHA konnte nicht verifiziert werden!'
  },
  common: {
    hide: 'Ausblenden',
    show: 'Anzeigen',
    loading: 'Wird geladen…',
    selectOption: 'Wähle eine Option',
    search: 'Suchen...',
    noOptions: 'Keine Optionen gefunden',
    searching: 'Suchen...',
    submitting: 'Übermitteln...',
    registerNow: 'Jetzt anmelden',
    closeButton: 'Schließen',
    notFoundAlt: 'nicht gefunden',
    errorIllustrationAlt: 'Fehlerdarstellung',
    badgeTrustpilotReviews: 'Trustpilot Bewertungen',
    ihrHeldenAlt: 'ihrHelden',
    downloadDataAsPdf: 'Deine Daten als PDF herunterladen',
    previousSlide: 'Vorherige Folie',
    nextSlide: 'Nächste Folie',
    goToSlide: 'Zu Folie {index}',
    loadingVideo: 'Video wird geladen',
    imagePlaceholderBlur: 'blur-sm',
    retailerImageAlt: 'Shop-Bild',
    darkModeToggleLabel: 'Dunkelmodus'
  },
  newsletterPopup: {
    headline: 'Lust auf exklusive Neuigkeiten?',
    description:
      'Hol Dir die HeldenPost und bleib über neue Deals, Infos und Sonderaktionen auf dem Laufenden.',
    subscribeButton: 'Abonnieren',
    declineButton: 'Nein, danke',
    subscribing: 'Wird abonniert...',
    imprint:
      'Du kannst Dich jederzeit in Deinem Profil oder direkt im Newsletter abmelden.',
    closeButton: 'Schließen'
  },
  heroData: {
    /** Trust line with the live redemption figure appended after a separator. */
    trustpilotRatingLine: '{stars} {rating} auf Trustpilot',
    /** Trust line when the Trustpilot rating stands on its own. */
    trustpilotRatingLineStandalone: '{stars} {rating} Sterne auf Trustpilot',
    /** Suffix for the live redemption count in the trust line. */
    redeemedSuffix: 'Rabatte bereits genutzt',
    title: 'Spare als Alltagsheld bei über 400 Partnern.',
    subtitle:
      'Sichere Dir exklusive Rabatte, die öffentlich nicht verfügbar sind.',
    /**
     * Hero CTA. Deliberately not `common.registerNow`: the hero tests a
     * benefit-focused wording while every other CTA on the page stays as it is.
     */
    ctaText: 'Kostenlos Vorteile sichern',
    eligibleGroups: [
      {
        header: '👩‍🏫 Erziehung, Schule & Bildung',
        description:
          '<b>Alles pädagogische Personal:</b> z.B. Erzieher:innen, Lehrer:innen, pädagogische Mitarbeiter:innen, Schul- & Inklusionsbegleiter:innen, Dozent:innen, Nachhilfelehrer:innen u.v.m. - <b>sowie</b> Verwaltung, Hauswirtschaft, Reinigung und weiteres Personal in Kitas, Kindergärten, Schulen, Berufsschulen, Universitäten u.v.m.'
      },
      {
        header: '🏥 Medizin, Pflege & Gesundheit',
        description:
          '<b>Alle Berufe im Gesundheitswesen</b>: z.B. Ärzt:innen aller Fachrichtungen, MFA, ZFA, TFA, Pflegekräfte aller Art inkl. Angehörigenpflege, Therapeutische Berufe (z.B. Podologie, Physio-, Ergo-, Logopädie, Ernährungstherapie), Psycholog:innen & Psychotherapeut:innen, Heilerziehungspfleger:innen, Apotheker:innen, PTA, Hebammen, medizinisch-technisches Personal, Haushaltshilfen u.v.m. - <b>sowie</b> Verwaltung, Küche, Hauswirtschaft, Sicherheit und Reinigung in allen medizinischen, therapeutischen und pflegerischen Einrichtungen.'
      },
      {
        header: '🚑 Rettungsdienste & Katastrophenschutz',
        description:
          'Alle Mitarbeitenden - <b>haupt- oder ehrenamtlich</b> - z.B. bei DRK, Johannitern, Maltesern, ASB, DLRG, THW, DGzRS, kommunalen & privaten Rettungsdiensten, Luft-, Berg-, Höhlen- & Wasserrettung sowie Rettungshundestaffeln u.v.m. - vom Rettungs- & Notfallsanitätsdienst über Leitstelle und Fahrdienste bis zu Technik, Verwaltung und Service.'
      },
      {
        header: '🚒 (Freiwillige) Feuerwehr',
        description:
          'Alle Angehörigen der Berufs-, Werk-, Betriebs- und freiwilligen Feuerwehren - <b>haupt- oder ehrenamtlich</b> - z.B. Einsatzkräfte, Feuerwehrsanitäter:innen, Leitstelle, Technik u.v.m. - <b>sowie</b> Verwaltung, Reinigung und Service in den Einrichtungen und Wachen.'
      },
      {
        header: '👮 Polizei',
        description:
          'Polizist:innen und Beschäftigte in allen Bereichen und Laufbahnen - <b>sowie</b> Verwaltung, Technik, IT, Reinigung, Sicherheit und weiteres Personal in den jeweiligen Einrichtungen.'
      },
      {
        header: '🎖️ Bundeswehr',
        description:
          'Soldat:innen inkl. Reservist:innen sowie zivile Beschäftigte der Bundeswehr - z.B. Sanitätsdienst, Technik, Verwaltung und weiteres unterstützendes Personal u.v.m.'
      },
      {
        header: '🏢 Öffentliche Einrichtungen & öffentlicher Dienst',
        description:
          'Alle <b>Beamten, Angestellten und Mitarbeitenden im öffentlichen Dienst</b>: z.B. in Behörden, Ordnungsamt, Justiz & Justizvollzug, Stadtverwaltungen, Agenturen für Arbeit, Bibliotheken, Sportstätten, Verkehrsbetriebe (z.B. DB, ÖPNV), öffentlichen Versorgern u.v.m. - <b>sowie</b> Verwaltung, Technik, Reinigung, Sicherheit und Hauswirtschaft.'
      },
      {
        header: '🤝 Gemeinnützige & soziale Organisationen',
        description:
          'Alle Mitarbeitenden - <b>haupt- oder ehrenamtlich</b> - in gemeinnützigen & sozialen Einrichtungen, z.B. AWO, Caritas, Diakonie, Lebenshilfe, Tafeln, Kirchengemeinden, Obdachlosen- & Hospizhilfe, Kinder-, Jugend- & Familienhilfe, Behindertenhilfe & Inklusion, betreutem Wohnen u.v.m. - z.B. Sozialarbeiter:innen, pädagogische, betreuende und therapeutische Kräfte sowie weiteres Personal.'
      },
      {
        header: '❤️ Ehrenamt & soziales Engagement',
        description:
          'Alle, die sich <b>freiwillig & ehrenamtlich engagieren</b>: z.B. Mitglieder, Vorsitzende & Helfer:innen in Kultur-, Sport-, Tierschutz- & Fördervereinen, Kirchengemeinden, Selbsthilfegruppen, sozialen Projekten, Initiativen, Nachbarschaftshilfe u.v.m.'
      },
      {
        header: '🎓 Ausbildung & Studium',
        description:
          '<b>Auf dem Weg zum Alltagshelden?</b> Auch Auszubildende, Anwärter:innen und Studierende in den oben genannten Bereichen sind bei uns herzlich willkommen.'
      },
      {
        header: '📩 Dein Beruf fehlt?',
        description:
          '👉 Kein Problem: Schreib uns an <b><a class="text-secondary hover:text-secondary/80 dark:text-blue-green dark:hover:text-blue-green/80 underline" href="mailto:kontakt@ihrhelden.de">kontakt@ihrhelden.de</a></b> - wir prüfen es sofort.'
      }
    ]
  },
  /**
   * Copy for the `/what-is-ihrHelden` landing-page A/B variants. Structural
   * behaviour (section order, meta flags) lives in
   * `src/constants/landing-variants/`; only user-visible strings belong here.
   *
   * `{memberCount}` is interpolated from the live deal-click report — never
   * hardcode the figure, it changes daily. `headlineFallback` is used when that
   * value isn't available, so no variant ever renders a placeholder.
   */
  landingExperiments: {
    defaultBenefits: ['Über 400 Partner', 'Kostenlos', 'In unter 2 Minuten'],
    valueAppreciation: {
      headline: 'Weil Du jeden Tag für andere da bist.',
      subheadline:
        'Als Dankeschön erhältst Du Zugang zu exklusiven Rabatten bei über 400 Partnern, die öffentlich nicht verfügbar sind.',
      benefits: ['Kostenlos', 'In unter 2 Minuten', 'Exklusive Rabatte'],
      ctaText: 'Jetzt Vorteile freischalten'
    },
    moneySaving: {
      /**
       * No euro figure: "mehrere hundert Euro" is a savings claim we cannot
       * substantiate per user, and a hero is the wrong place to make one.
       */
      headline: 'Spare mit exklusiven Rabatten das ganze Jahr.',
      subheadline:
        'Exklusive Rabatte auf Technik, Reisen, Mode, Sport und mehr – nur für verifizierte Alltagsheld:innen.',
      benefits: ['Über 400 Partner', 'Kostenlos', 'Exklusive Rabatte'],
      // Saving only starts after registration and verification, so the CTA
      // promises the benefit rather than the act of saving.
      ctaText: 'Kostenlos Vorteile sichern',
      featuredTitle: 'Diese Angebote sichern Dir sofort Rabatt',
      guaranteed: {
        title: 'Spare bei über 400 Partnern.',
        subtitle:
          'Bei uns findest Du nur geprüfte und aktuelle Angebote – exklusiv für Alltagshelden wie Dich.',
        content:
          'Geprüfte Rabatte, die wirklich funktionieren – Technik, Reisen, Mode, Sport und mehr.'
      }
    },
    exclusivity: {
      headline: 'Diese Rabatte bekommt nicht jeder.',
      subheadline:
        'Nur verifizierte Alltagsheld:innen erhalten Zugang zu exklusiven Rabatten bei über 400 Partnern.',
      ctaText: 'Exklusiven Zugang erhalten'
    },
    socialProof: {
      headline: '{memberCount} Alltagsheld:innen sparen bereits mit ihrHelden.',
      headlineFallback:
        'Tausende Alltagsheld:innen sparen bereits mit ihrHelden.',
      // No "größte Plattform" claim we cannot back up; the product benefit
      // carries more weight here anyway.
      subheadline: 'Sichere Dir exklusive Rabatte bei über 400 Partnern.',
      ctaText: 'Kostenlos Vorteile sichern'
    },
    recognition: {
      headline: 'Ein Dankeschön allein reicht nicht.',
      subheadline:
        'Deshalb bekommst Du als Alltagsheld:in exklusive finanzielle Vorteile.',
      benefits: ['Kostenlos', 'Exklusive Rabatte', 'Nur für Alltagsheld:innen'],
      ctaText: 'Kostenlos Vorteile sichern'
    },
    utility: {
      headline: 'Exklusive Rabatte für Alltagsheld:innen.',
      benefits: ['Über 400 Partner', 'Kostenlos', 'In unter 2 Minuten'],
      ctaText: 'Kostenlos Vorteile sichern',
      guaranteed: {
        title: 'Über 400 Partner. Ein Login.',
        subtitle:
          'Technik, Reisen, Mode, Sport, Versicherungen und mehr – alles an einem Ort.',
        // Number-free on purpose: the control fallback under this heading would
        // quote the €500/year figure this PR drops everywhere else.
        content:
          'Exklusive Rabatte bei über 400 Partnern – geprüft und aktuell.'
      }
    },
    fomo: {
      /**
       * Two different live figures on purpose: members in the badge,
       * redemptions in the headline. Quoting `{memberCount}` in both would
       * state one metric twice and make this headline identical to
       * `socialProof`'s — two cells that read the same cannot be compared.
       * The badge is dropped when its figure is missing; the headline falls
       * back to number-free wording.
       */
      tagline: 'Bereits {memberCount} Alltagsheld:innen dabei',
      headline: '{redeemedCount} Rabatte wurden bereits genutzt.',
      headlineFallback: 'Alltagsheld:innen nutzen unsere Rabatte jeden Tag.',
      subheadline:
        'Sichere Dir exklusive Rabatte, die öffentlich nicht verfügbar sind.',
      ctaText: 'Jetzt Vorteile sichern',
      trendingTitle: 'Gerade besonders gefragt'
    }
  },
  whatIsIhrhelden: {
    topNav: 'Was ist ihrHelden?',
    partners: {
      sectionTitle: 'Unsere Partner',
      paragraphs: `
      <strong>Bei unseren Partnern kannst Du richtig sparen und so merklich mehr für Dein Geld erhalten.</strong>
      <br/><br/>
      Hierbei haben wir Dir ein tolles Sortiment aus allen Bereichen des täglichen Lebens zusammengestellt, das wir kontinuierlich erweitern und verbessern.
      <br/><br/>
      <strong>Das Beste: Unsere <strong>Gutscheincodes</strong> funktionieren wirklich.</strong>
      <br/><br/>
      Bei uns findest Du nur geprüfte und aktuelle Angebote – exklusiv für Alltagshelden wie Dich.
      <br/><br/>
      Nutze einfach den passenden Gutschein-Code und setze ihn beim Online-Shopping bei unseren Partnern ein.
    `
    },
    partnership: {
      subtitle: '🤝 Offizielle Kooperation',
      buttonText: 'Mehr erfahren im Blog',
      buttonLink: 'https://blog.ihrhelden.de/partner',
      partners: {
        thw: {
          alt: 'Logo der THW Bundesvereinigung e.V.',
          description:
            'Gemeinsam mit der THW Bundesvereinigung e.V. setzen wir uns dafür ein, Angehörigen der THW-Helfervereinigung echte Vorteile im Alltag zu ermöglichen.'
        },
        reservistenverband: {
          alt: 'Logo des Verbands der Reservisten der Deutschen Bundeswehr e.V.',
          description:
            'Gemeinsam mit dem Reservistenverband setzen wir uns dafür ein, Reservistinnen und Reservisten echte Vorteile im Alltag zu ermöglichen.'
        },
        ehrenamtskarteMv: {
          alt: 'Ehrenamtskarten aus Schleswig-Holstein, Niedersachsen und Bremen, Mecklenburg-Vorpommern und Hamburg',
          description: 'Wir sind Partner der Ehrenamtskarte MV.'
        }
      }
    },
    easySignUp: {
      sectionTitle: 'Die Anmeldung bei uns ist ganz einfach!',
      paragraphs: `
      <h3><strong>In unter 1 Minute angemeldet</strong></h3>
      <br/>
      <h3><strong>1. Account erstellen</strong></h3>
      <p>Vor- und Nachname sowie Deine E-Mail-Adresse genügen.</p>
      <br/><br/>
      <h3><strong>2. Heldenstatus kurz bestätigen</strong></h3>
      <p>Zeig uns einfach, dass Du zu unseren Alltagsheld:innen gehörst:</p>
      <ul class="list-disc ml-5 mt-2">
        <li><strong>mit Deiner Arbeits-E-Mail-Adresse</strong> (@DeinArbeitgeber.de)</li>
        <li><strong>oder Foto von beliebigem Nachweis hochladen</strong>: z.B. Dienstausweis, Namensschild, Urkunde, Weiterbildungsnachweis, Screenshot einer Mitarbeiter-App oder geschwärzter Gehaltsabrechnung / Arbeitsvertrag.</li>
      </ul>
      <br/>
      <p><strong>Wichtig:</strong> Uns reicht, wenn erkennbar ist, dass Du in einem berechtigten Bereich tätig bist. <strong>Persönliche Daten kannst Du jederzeit schwärzen.</strong></p>
      <br/>
      <p><strong>🔒 Datenschutzgarantie:</strong><br/>Hochgeladene Nachweise werden nur zur Verifizierung angesehen und <strong>direkt danach gelöscht. Sie werden nicht gespeichert.</strong></p>
      <br/>
      <strong>Weitere Infos zu ihrHelden.de findest Du auf unserer <a href="/about" style="text-decoration: underline;">Über-uns-Seite</a>.</strong>
    `
    },
    dealsCarousel: {
      title: 'Finde Deals die zu Dir passen'
    },
    video: {
      iframeTitle: 'ihrHelden auf Instagram: So funktioniert’s'
    },
    guaranteedSavings: {
      title: 'Das Beste: Unsere Gutscheincodes funktionieren wirklich.',
      subtitle:
        'Bei uns findest Du nur geprüfte und aktuelle Angebote – exklusiv für Alltagshelden wie Dich.',
      content:
        'Unsere Alltagshelden sparen mit unseren Rabatten im Schnitt bis zu 500€ pro Jahr.'
    }
  },
  savedDeals: {
    expired: 'Abgelaufen',
    countdown: {
      prefix: 'Noch',
      day: 'Tag',
      days: 'Tage'
    },
    error: {
      title: 'Fehler beim Laden',
      description:
        'Upps! Wir konnten Deine gespeicherten Deals nicht laden. Bitte versuche es erneut.',
      retry: 'Erneut versuchen'
    },
    empty: {
      title: 'Du hast noch keine Deals gespeichert.',
      description:
        'Klicke auf den Stern bei einem Deal, um ihn hier zu speichern.',
      cta: 'Deals entdecken'
    },
    notifyWidget: {
      offHeadline:
        'Lass Dich benachrichtigen, wenn Deine gespeicherten Deals wieder verfügbar sind oder bald ablaufen.',
      enableButton: 'Benachrichtigungen aktivieren',
      onHeadline:
        'Benachrichtigungen aktiv – wir informieren Dich, wenn Deine gespeicherten Deals wieder verfügbar sind oder bald ablaufen.',
      manage: 'Im Profil verwalten',
      blockedHeadline:
        'Benachrichtigungen sind in Deinem Browser blockiert. Aktiviere sie in den Browsereinstellungen, um Hinweise zu erhalten.',
      blockedCta: 'So geht’s',
      iosHeadline:
        'Auf dem iPhone funktionieren Benachrichtigungen, sobald Du ihrhelden zum Home-Bildschirm hinzufügst — geht in wenigen Sekunden.',
      iosInstallCta: 'So geht’s',
      iosOtherBrowserHeadline:
        'Benachrichtigungen auf dem iPhone funktionieren nur in Safari. Öffne diese Seite in Safari, um sie zu aktivieren.',
      iosOtherBrowserCta: 'Seitenlink kopieren',
      iosOtherBrowserCopied: 'Link kopiert — füge ihn in Safari ein.',
      dismiss: 'Ausblenden'
    },
    blockedHelp: {
      title: 'Browser-Benachrichtigungen aktivieren',
      intro:
        'Dein Browser blockiert Benachrichtigungen für ihrhelden.de. Folge den Schritten für Deinen Browser:',
      browserLabel: {
        chromeDesktop: 'Chrome (Desktop)',
        chromeAndroid: 'Chrome (Android)',
        safariMacos: 'Safari (Mac)',
        safariIos: 'Safari (iPhone / iPad)',
        firefoxDesktop: 'Firefox (Desktop)',
        firefoxAndroid: 'Firefox (Android)',
        edgeDesktop: 'Edge (Desktop)',
        other: 'Andere Browser'
      },
      steps: {
        chromeDesktop: [
          'Klicke auf das Schloss- oder Einstellungs-Symbol links in der Adressleiste.',
          'Wähle „Website-Einstellungen" (oder klappe „Benachrichtigungen" auf).',
          'Stelle Benachrichtigungen auf „Zulassen" und lade die Seite neu.'
        ],
        chromeAndroid: [
          'Tippe auf das Schloss-Symbol links in der Adressleiste.',
          'Tippe auf „Berechtigungen" → „Benachrichtigungen".',
          'Wähle „Zulassen" und lade die Seite neu.'
        ],
        safariMacos: [
          'Öffne Safari → Einstellungen → Websites.',
          'Wähle in der Seitenleiste „Mitteilungen".',
          'Finde ihrhelden.de in der Liste und stelle es auf „Erlauben".'
        ],
        safariIos: [
          'Öffne das Teilen-Menü und tippe auf „Zum Home-Bildschirm".',
          'Öffne ihrhelden über das neue Symbol auf dem Home-Bildschirm.',
          'Wenn Du gefragt wirst, tippe auf „Erlauben", um Benachrichtigungen zu aktivieren.'
        ],
        firefoxDesktop: [
          'Klicke auf das Schloss- oder Schild-Symbol links in der Adressleiste.',
          'Öffne „Verbindung sicher" → „Weitere Informationen" → „Berechtigungen" (oder nutze das Schloss-Menü).',
          'Stelle Benachrichtigungen auf „Erlauben" und lade die Seite neu.'
        ],
        firefoxAndroid: [
          'Tippe auf das Schloss-Symbol links in der Adressleiste.',
          'Tippe auf „Website-Einstellungen" → „Benachrichtigungen".',
          'Wähle „Erlauben" und lade die Seite neu.'
        ],
        edgeDesktop: [
          'Klicke auf das Schloss-Symbol links in der Adressleiste.',
          'Wähle „Berechtigungen für diese Website".',
          'Stelle Benachrichtigungen auf „Zulassen" und lade die Seite neu.'
        ],
        other:
          'Öffne die Browsereinstellungen, finde die Berechtigungen für ihrhelden.de und erlaube Benachrichtigungen. Lade dann die Seite neu.'
      },
      close: 'Schließen'
    },
    iosInstall: {
      title: 'ihrhelden zum Home-Bildschirm hinzufügen',
      intro:
        'iPhone-Benachrichtigungen benötigen ihrhelden als Home-Bildschirm-App. Drei schnelle Schritte:',
      steps: [
        {
          headline: 'Tippe auf das Teilen-Symbol',
          detail:
            'Das Quadrat mit dem Pfeil nach oben unten in Safari (oben rechts auf dem iPad).'
        },
        {
          headline: 'Tippe auf „Zum Home-Bildschirm"',
          detail:
            'Scrolle im Teilen-Menü nach unten, falls Du es nicht sofort siehst.'
        },
        {
          headline: 'Öffne ihrhelden vom Home-Bildschirm',
          detail:
            'Tippe auf das neue Symbol. Tippe auf „Erlauben", wenn Du gefragt wirst, um Benachrichtigungen zu aktivieren.'
        }
      ],
      noteHeadline: 'Schon auf dem Home-Bildschirm?',
      noteDetail:
        'Öffne ihrhelden über das Home-Bildschirm-Symbol, um Benachrichtigungen zu aktivieren.',
      close: 'Verstanden'
    }
  },
  bookmarkButton: {
    add: 'Deal speichern',
    remove: 'Gespeicherten Deal entfernen'
  },
  bookmarksTour: {
    next: 'Weiter →',
    done: 'Fertig ✓',
    step1: {
      title: 'Deal speichern',
      description: 'Klicke auf den Stern, um einen Deal zu speichern.'
    },
    step2: {
      title: 'Meine Deals',
      description: 'Hier findest Du alle Deine gespeicherten Deals.'
    }
  }
};
